import * as React from 'react';

import { FIELD_PATHS } from '@funnels/constants';

import { NumeralDisplay, DollarInputField } from '../../Fields';
import { NumericalReadOnlyViewProps, EditableViewProps } from '../types';

interface RentalIncomeEditableViewProps extends EditableViewProps {
  label?: string;
  incomeIndex: number;
  validate?: (value: any) => void;
}

export const RentalIncomeEditableView = (props: RentalIncomeEditableViewProps) => {
  const { label = 'Amount', incomeIndex, ...rest } = props;
  return <DollarInputField {...rest} isZeroValid={true} label={label} name={FIELD_PATHS.INCOME_AMOUNT(incomeIndex)} />;
};

export function RentalIncomeReadOnlyView(props: NumericalReadOnlyViewProps) {
  return <NumeralDisplay title={'Rental income'} before={'$'} value={props.value} after={props.after} />;
}
